import React     from 'react';
import PropTypes from 'prop-types';

class ActorAvatar extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		const styles = {
			width:  this.props.size + 'px',
			height: this.props.size + 'px',
		};

		let classes = '';

		if (!this.props.actorUrlPreviewPicture) {
			classes += ' is-placeholder';
		}

		if (this.props.isOnline) {
			classes += ' is-online';
		} else {
			classes += ' is-offline';
		}

		if (this.props.className) {
			classes += ' ' + this.props.className;
		}

		return (
			<a href={this.props.actorUrl} onClick={this.props.onClickFn ? this.props.onClickFn : undefined}>
				<span className={'guest-avatar__container' + classes}>
					<span className={"guest-avatar__image-wrapper"}
					      style={styles}
					>
						{this.props.actorUrlPreviewPicture &&
						<img src={this.props.actorUrlPreviewPicture} className="guest-avatar__image" alt={this.props.actorName} />}
					</span>
					{this.props.actorName && <span className="h-disp-block h-text-align-center h-over-ellipsis">
						<span className={"guest-avatar__label -no-margin-top -font-weight-light " + this.props.labelClassName}>
							{this.props.actorName}{this.props.actorAge && <span>({this.props.actorAge})</span>}
						</span>
					</span>}
				</span>
			</a>
		);
	}
}

ActorAvatar.propTypes = {
	actorName:              PropTypes.string,
	actorAge:               PropTypes.number,
	actorUrl:               PropTypes.string,
	actorUrlPreviewPicture: PropTypes.string,
	className:              PropTypes.string,
	isOnline:               PropTypes.bool,
	onClickFn:              PropTypes.func,
	size:                   PropTypes.number,
	labelClassName:         PropTypes.string,
};

ActorAvatar.defaultProps = {
	actorUrl:               '',
	actorUrlPreviewPicture: '',
	size:                   80,
	labelClassName:         '',
};

export default ActorAvatar;
